export function getAsAhexFromHexa(hexa: string) {
  if (hexa.startsWith("#")) {
    hexa = hexa.substring(1);
  }
  if (hexa.length !== 8) {
    throw new Error("Invalid hexa value.");
  }
  return `${hexa.slice(6, 8)}${hexa.slice(0, 6)}`;
}

export function getAsHexaFromAhex(ahex: string) {
  if (ahex.startsWith("#")) {
    ahex = ahex.substring(1);
  }
  if (ahex.length !== 8) {
    throw new Error("Invalid ahex value.");
  }
  return `${ahex.slice(2, 8)}${ahex.slice(0, 2)}`;
}

export function getHexFromAhex(ahex: string) {
  if (ahex.startsWith("#")) {
    ahex = ahex.substring(1);
  }
  if (ahex.length !== 8) {
    throw new Error("Invalid ahex value.");
  }
  return `${ahex.slice(2, 8)}`;
}

export function getHexFromHexa(hexa: string) {
  if (hexa.startsWith("#")) {
    hexa = hexa.substring(1);
  }
  if (hexa.length !== 8) {
    throw new Error("Invalid hexa value.");
  }
  return `${hexa.slice(0, 6)}`;
}
